import styled from 'styled-components';

export const Container = styled.div``;

export const UnitName = styled.p`
  font: 14px Montserrat;
  font-weight: 500;
  line-height: 22px;
  color: #898b8e;
`;

export const UnitPhone = styled.a`
  font: 16px Montserrat;
  font-weight: 500;
  line-height: 22px;
  color: #004f92;
  text-decoration-color: #004f92;
  display: block;
`;
